import _ from 'lodash';
import Cookies from 'js-cookie';

export default {
  set(rate) {
    Cookies.set('preferred_playback_rate', rate, { expires: 30, path: '/' });
  },

  get() {
    let rate = parseFloat(Cookies.get('preferred_playback_rate'));
    if (_.isNaN(rate)) {
      rate = 1;
      this.set(rate);
    }
    return rate;
  },
};
